<template>
    <div>
        <v-form name="manageDetailsForm" ref="manageDetailsForm">
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-6 tw-p-1">
                <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/3 tw-gap-2 section"><!-- left side -->
                    <v-text-field
                        v-show="isEdit"
                        v-model="member.id"
                        label="User ID"
                        hide-details="auto"
                        readonly
                        dense
                    ></v-text-field>
                    <v-text-field
                        v-model="member.first_name"
                        label="First Name"
                        :error-messages="errors?.first_name"
                        :rules="[rules.required]"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-text-field
                        v-model="member.last_name"
                        label="Last Name"
                        :error-messages="errors?.last_name"
                        :rules="[rules.required]"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-text-field
                        :disabled="!member.web_access"
                        v-model="member.email"
                        label="Login Email"
                        :error-messages="errors?.email"
                        :rules="!member.web_access ? [] : [rules.requiredEmail]"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <div class="float-right">
                        <v-btn @click="sendWelcomeMail" class="btn-primary text-right">
                            Send Welcome Email
                        </v-btn>
                    </div>
                    <v-text-field
                        :disabled="!member.web_access"
                        v-model="member.mobile_phone"
                        label="Login Phone"
                        :error-messages="errors?.mobile_phone"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-checkbox
                        v-model="member.is_intl_phone"
                        label="International Phone"
                        :error-messages="errors?.is_intl_phone"
                        hide-details="auto"
                        dense
                        :false-value="0"
                        :true-value="1"
                    ></v-checkbox>
                    <v-text-field
                        v-model="member.company"
                        label="Company"
                        :error-messages="errors?.company"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-text-field
                        v-model="member.designation"
                        label="Designation"
                        :error-messages="errors?.designation"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-select
                        v-model="member.language"
                        :items="getLanguages"
                        label="Language"
                        :error-messages="errors?.language"
                        hide-details="auto"
                        dense
                        reactive
                        outlined
                        clearable
                    ></v-select>
                    <v-text-field
                        v-model="member.local"
                        label="local"
                        :error-messages="errors?.local"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-text-field
                        v-model="member.internal_code"
                        label="Internal Code"
                        :error-messages="errors?.internal_code"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-select
                        v-model="member.member_status_id"
                        :items="valuelist.CLASSIFICATIONS"
                        label="Classification"
                        display-label="Classification"
                        :error-messages="errors?.member_status_id"
                        hide-details="auto"
                        dense
                        reactive
                        outlined
                        clearable
                    />
                    <v-text-field
                        :value="findValuelist(this.valuelist.STATUS_NAMES, member.member_status_id)?.text"
                        label="Status"
                        hide-details="auto"
                        readonly
                        dense
                    ></v-text-field>
                    <v-text-field
                        v-show="isEdit"
                        v-model="member.status_updated_at"
                        label="Date (Status change)"
                        hide-details="auto"
                        readonly
                        dense
                    ></v-text-field>
                    <v-text-field
                        v-show="isEdit"
                        v-model="member.website"
                        label="Website"
                        hide-details="auto"
                        dense
                    ></v-text-field>
                    <v-text-field
                        v-show="isEdit"
                        v-model="member.demo_reel"
                        label="Demo Reel"
                        hide-details="auto"
                        dense
                    ></v-text-field>
                </div>

                <div class="tw-flex tw-flex-col tw-gap-2 section"><!-- middle -->
                    <v-checkbox
                        v-model="member.web_access"
                        label="Web Access"
                        :error-messages="errors?.web_access"
                        hide-details="auto"
                        dense
                        :false-value="0"
                        :true-value="1"
                    ></v-checkbox>
                    <v-checkbox
                        v-model="member.print_statement"
                        label="Print Statement"
                        :error-messages="errors?.print_statement"
                        hide-details="auto"
                        dense
                        :false-value="0"
                        :true-value="1"
                    ></v-checkbox>
                    <v-checkbox
                        v-model="member.casl"
                        label="CASL"
                        :error-messages="errors?.casl"
                        hide-details="auto"
                        dense
                        :false-value="0"
                        :true-value="1"
                    ></v-checkbox>
                    <v-checkbox
                        v-model="member.sheridan_workshop"
                        label="Sheridan Workshop"
                        :error-messages="errors?.sheridan_workshop"
                        hide-details="auto"
                        dense
                        :false-value="0"
                        :true-value="1"
                    ></v-checkbox>
                    <v-checkbox
                        v-model="member.set_etiquette"
                        label="Set Etiquette"
                        :error-messages="errors?.set_etiquette"
                        hide-details="auto"
                        dense
                        :false-value="0"
                        :true-value="1"
                    ></v-checkbox>
                    <v-checkbox
                        v-model="member.two_factor_confirmed"
                        label="2FA Confirmed"
                        :error-messages="errors?.two_factor_confirmed"
                        hide-details="auto"
                        dense
                        :false-value="0"
                        :true-value="1"
                    ></v-checkbox>
                </div>

                <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/3 tw-gap-2  section"><!-- right side -->
                    <v-select
                        v-model="member.role"
                        :items="valuelists.USER_ROLES_ASSIGNABLE"
                        label="User Access"
                        :error-messages="errors?.role"
                        hide-details="auto"
                        dense
                        reactive
                        outlined
                        clearable
                    ></v-select>
                    <v-text-field
                        v-model="member.other_prod_details"
                        label="Other Prod Details"
                        :error-messages="errors?.other_prod_details"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-select
                        v-model="member.region"
                        :items="getRegions"
                        label="Region"
                        :error-messages="errors?.region"
                        hide-details="auto"
                        dense
                        reactive
                        outlined
                        clearable
                    ></v-select>
                    <v-checkbox
                        v-model="member.age_25_and_65"
                        label="25/65"
                        :error-messages="errors?.age_25_and_65"
                        hide-details="auto"
                        dense
                        :false-value="0"
                        :true-value="1"
                    ></v-checkbox>
                    <v-checkbox
                        v-model="member.ia_retiree"
                        label="IARetiree"
                        :error-messages="errors?.ia_retiree"
                        hide-details="auto"
                        dense
                        :false-value="0"
                        :true-value="1"
                    ></v-checkbox>
                    <v-text-field
                        v-show="isEdit"
                        v-model="member.agent_name"
                        label="DP Agent Name"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-text-field
                        v-show="isEdit"
                        v-model="member.agent_agency"
                        label="Agency"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-text-field
                        v-show="isEdit"
                        v-model="member.agent_phone_number"
                        label="Agent Phone"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-checkbox
                        v-model="member.mentor"
                        label="Mentor"
                        :error-messages="errors?.mentor"
                        hide-details="auto"
                        dense
                        :false-value="0"
                        :true-value="1"
                    ></v-checkbox>
                    <v-text-field
                        v-model="member.mentor_note"
                        :disabled="!member.mentor"
                        label="Mentor Notes"
                        :error-messages="errors?.mentor_note"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <date-picker
                        v-model="member.date_ia_membership"
                        dense
                        hide-details="auto"
                        color="primary"
                        display-label="IATSE667 Membership Date"
                        reactive
                        :error-messages="errors?.date_ia_membership"
                        >
                    </date-picker>
                    <date-picker
                        v-model="member.date_reinstatement"
                        dense
                        hide-details="auto"
                        color="primary"
                        display-label="Date of Earliest IA Membership"
                        reactive
                        :error-messages="errors?.date_reinstatement"
                        >
                    </date-picker>
                    <date-picker
                        v-model="member.date_termination"
                        dense
                        hide-details="auto"
                        color="primary"
                        display-label="Termination Date"
                        reactive
                        :error-messages="errors?.date_termination"
                        >
                    </date-picker>
                    <v-textarea
                        v-model="member.base_dues_note"
                        outlined
                        auto-grow
                        label="Base Dues & Fees Notes"
                        hide-details="auto"
                    />
                    <v-file-input
                        v-model="member.new_uploaded_resumes"
                        label="Resume"
                        dense
                        outlined
                        hide-details
                        :prepend-icon="null"
                    >
                    </v-file-input>
                    <div v-if="isEdit && member.uploaded_resumes && member.uploaded_resumes.length > 0">
                        Active resume:
                        <a :href="getResumeUrl()" target="_blank">
                            {{ member.uploaded_resumes[0].file_name }}
                        </a>
                        <v-icon @click="deleteResume(member.id)">mdi-delete</v-icon>
                    </div>

                </div>
            </div>
            <div class="tw-p-1" v-show="isUserAdmin">
                <v-btn v-show="isEdit" @click="archiveMember" :loading="archiveLoading" class="main-btn">Delete User</v-btn>
            </div>
        </v-form>


    </div>

</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import DatePicker from "@/Generic/DatePicker.vue";

    export default {
        name: "MembersManageDetails",
        components: {
            DatePicker,
            SmartTable,
            InternalHeader,
        },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return {}
                }
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'isEditProp': {
                type: Boolean,
                required:false,
                default: function() {
                    return false
                }
            },
        },
        data() {
            return {
                member: this.input || {},
                constant: this.constants,
                valuelist: this.valuelists,
                saveLoading: false,
                archiveLoading: false,
                isEdit: this.isEditProp,
                rules: {
                    required: value => !!value || 'Required',
                    requiredEmail: (value) => /^[^\s@]+@[^\s@\.]+\.[a-z]{2,}$/.test(value) || 'Invalid Email address',
                },
                emailClone: structuredClone(this.input.email),
                errors: null,
            }
        },
        computed: {
            getRegions() {
                return Object.values(this.constant.MEMBER_REGIONS)
            },
            getLanguages() {
                return Object.values(this.constant.MEMBER_LANGUAGES)
            },
            isUserAdmin() {
                if (this.$page.user.role === 'ADMIN') {
                    return true
                } else {
                    return false
                }
            }
        },
        methods: {
            getResumeUrl() {
                if (this.member.uploaded_resumes && this.member.uploaded_resumes.length > 0) {
                    const userId = this.member.id
                    const fileName = this.member.uploaded_resumes[0].file_name
                    return `/storage/user_resumes/${userId}/${fileName}`
                }
                return null
            },
            findValuelist(list, id) {
                if (list && id) {
                    return list.find(obj => obj.value === id)
                } else {
                    return ""
                }
            },
            saveDetails() {
                if (this.$refs.manageDetailsForm.validate()) {
                    let formData = new FormData();

                    console.log(this.member)
                    for (let key in this.member) {
                        if (this.member[key] !== null
                            && this.member[key] !== undefined
                            && this.member[key] !== 'undefined'
                        ) { // Adding three as system is not stable with this from time to time
                            formData.append(key, this.member[key])
                        } else {
                            formData.append(key, '')
                        }
                    }

                    // Handle the file input separately
                    if (this.member.new_uploaded_resumes) {
                        formData.append('new_uploaded_resumes', this.member.new_uploaded_resumes);
                    }

                    var url = ''

                    if( this.isEdit ) {
                        url = route('members.update', this.member.id)
                        formData.append("updated_by",this.$page.user.id)
                        formData.append("_method", "put")
                    } else {
                        formData.append("user_id", this.member_id)
                        url = route('members.store')
                    }

                    axios({
                        method: 'post',
                        url: url,
                        data: formData,
                        onUploadProgress: (evt) => {
                            this.saveLoading = !this.saveLoading
                        },
                        onDownloadProgress: (evt) => {
                            this.saveLoading = !this.saveLoading
                        },
                    })
                        .then(response =>
                        {
                            if (response.data.success) {
                                this.$root.is_dirty = false
                                this.$root.snackbar.success('Changes have been saved')
                                this.dialog = false
                                this.$root.is_dirty = false
                                this.saveLoading = false
                                this.$emit('successful-manage-member-save')
                                this.emailClone = structuredClone(this.member.email)

                                if (!this.isEdit) {
                                    this.$inertia.visit(route('members.edit', response.data.data.id))
                                }
                            } else if( response.data?.error ) {
                                throw (response.data?.error)
                            } else {
                                throw ('Unknown error.')
                            }
                        })
                        .catch((error) => {
                            if( error?.response ) {
                                this.$root.snackbar.error(error.response.data.message)
                                this.errors = error.response?.data?.errors
                            } else {
                                console.log(error)
                                this.$root.snackbar.error(error)
                            }
                            this.saveLoading = false
                        })
                } else {
                    this.$root.snackbar.error('Please fill all required fields.')
                }
            },
            async archiveMember()
            {
                if (await this.$root.confirm.open(`Delete User`, `You are about to delete ${this.member.first_name} ${this.member.last_name} #${this.member.id}`)) {

                    let method = 'delete'
                    let url = route('members.destroy', this.member.id)
                    let payload = this.member

                    axios({
                        method: method,
                        url: url,
                        data: payload,
                        onUploadProgress: (evt) => {
                            this.archiveLoading = !this.archiveLoading
                        },
                        onDownloadProgress: (evt) => {
                            this.archiveLoading = !this.archiveLoading
                        },
                    })
                        .then(response => {
                            if (response.data.success) {
                                this.$root.is_dirty = false
                                this.$root.snackbar.success('Member has been deleted')
                                this.dialog = false
                                this.$root.is_dirty = false
                                this.archiveLoading = false
                                this.$emit('successful-member-delete')

                                this.$inertia.visit(route('members.index'))
                            } else {
                                throw (response.data.error)
                            }
                        })
                        .catch((error) => {
                            this.$root.snackbar.error(error.response.data.message)
                            this.archiveLoading = false
                        })
                }
            },
            async deleteResume() {
                if (await this.$root.confirm.open(`Delete Resume`, `You are about to delete the resume of ${this.member.first_name} ${this.member.last_name}. This action cannot be undone. Are you sure you want to continue?`)) {
                    let method = 'delete';
                    let url = route('members.deleteResume', this.member.id)
                    let payload = { userId: this.member.id }

                    axios({
                        method: method,
                        url: url,
                        data: payload,
                        onUploadProgress: (evt) => {
                        },
                        onDownloadProgress: (evt) => {
                        },
                    })
                        .then(response => {
                            if (response.data.success) {
                                this.$root.snackbar.success('Resume has been deleted')
                                this.$emit('successful-manage-member-save')
                            } else {
                                throw (response.data.error)
                            }
                        })
                        .catch((error) => {
                            this.$root.snackbar.error(error.response.data.message)
                        });
                }
            },
            async sendWelcomeMail() {
                if (
                    await this.$root.confirm.open(
                        'Send Welcome Email?',
                        `This will send a welcome email to the Login Email address that is currently saved for this user.  Are you sure you would like to continue?`
                    )
                ) {
                    // User wants to proceed.  Let's send
                    try {
                        let route_name = 'user.send.initial-password'
                        let user_id = this.input?.id

                        axios.post(route(route_name, user_id).url()).then((response) => {
                            this.$root.snackbar.success("Welcome message sent successfully")
                        })
                    } catch ($ex) {
                        this.$root.snackbar.error($ex)
                    }
                }

            },
        },
        watch: {
            input(newInput, oldInput) {
                this.member = newInput
            },
            saveLoading(newValue, oldValue) {
                this.$emit('save-loading-change', newValue)
            },
            'member.web_access'(newValue, oldValue) {
                if (!newValue) {
                    this.member.email = this.emailClone
                }
            },
            'member.mobile_phone'(newValue, oldValue) {
                if (newValue === '') {
                    this.$set(this.member, 'mobile_phone', null)
                    // this.$set(this.member, 'two_factor_confirmed', false)
                }
                else if(this.member.is_intl_phone) {
                    this.$set(this.member, 'mobile_phone', newValue) // leave unformatted
                }
                else {
                    this.$set(this.member, 'mobile_phone', this.$root.formatPhoneDisplay(newValue))
                    // this.$set(this.member, 'two_factor_confirmed', true)
                }
            },
        }
    }
</script>
<style scoped>

.section > .v-input{
    flex-grow: 0;
}

</style>
